<template>
  <div class="airportForecast">
    <div class="weatherLogo">
      <!-- <div class="check" @click="eleChange(0, $event)">
        <span>气温</span
        ><img
          class="dark"
          src="../../assets/img/weartherLogo/icon-tmpd.png"
        /><img class="light" src="../../assets/img/weartherLogo/icon-tmp.png" />
      </div>
      <div @click="eleChange(1, $event)">
        <span>降水</span
        ><img
          class="dark"
          src="../../assets/img/weartherLogo/icon-7d.png"
        /><img class="light" src="../../assets/img/weartherLogo/icon-7.png" />
      </div>
      <div @click="eleChange(2, $event)">
        <span>气压</span
        ><img
          class="dark"
          src="../../assets/img/weartherLogo/icon-5d.png"
        /><img class="light" src="../../assets/img/weartherLogo/icon-5.png" />
      </div> -->
      <div class="check" @click="eleChange(3, $event)">
        <span>风</span
        ><img
          class="dark"
          src="../../assets/img/weartherLogo/icon-4d.png"
        /><img class="light" src="../../assets/img/weartherLogo/icon-4.png" />
      </div>
    </div>
    <mapLegend
      v-show="eleIndex != 6 && eleIndex != 9"
      id="btmMapLegend"
      :styleColor="legndStyle"
      bottom="80"
      left="20"
      :unit="unit"
    ></mapLegend>
    <div v-show="percent" class="shadowBox">
      <i-circle
        :percent="percent"
        class="ivu-chart-circle"
        style="background: aliceblue; border-radius: 60px"
      >
        <p style="font-size: 16px; margin-bottom: 5px">努力加载中</p>
        <span class="demo-Circle-inner" style="font-size: 20px">
          {{ percent }}%</span
        >
      </i-circle>
    </div>
    <div id="bottomPanel" class="bottomPanel">
      <!-- <div class="bottomPanelImg" flag="noActive">
                <img src="images/panel/bottom.png"/>
            </div> -->
      <div
        id="bottomPanelDetail"
        flag="null"
        style="width: 100%; clear: both"
      ></div>
    </div>
    <div class="airPortInfo" v-show="false">
      <Select v-model="airPortSelect" filterable @on-change="changeAirPort">
        <Option
          v-for="item in airPortInfo"
          :value="item.ename"
          :key="item.ename"
          >{{ item.aname }}</Option
        >
      </Select>
    </div>
    <div class="gridEchart" id="gridEchart" v-show="gridEchart">
      <div style="height: 22px">
        <RadioGroup
          style="float: left; padding-left: 10px"
          v-model="ecElement"
          @on-change="changeElement"
        >
          <Radio label="气温"></Radio>
          <Radio label="降水"></Radio>
          <Radio label="气压"></Radio>
          <Radio label="风"></Radio>
        </RadioGroup>
        <!-- <span style="float: right;padding-right: 10px;">X</span> -->
        <Icon
          style="float: right; padding-right: 10px;cursor: pointer;"
          type="md-close-circle"
          size="20"
          @click="gridEchart = false"
        />
        <span style="float: right; padding-right: 20px"
          >经度：{{ gridLonlat.lon.toFixed(6) }} 纬度：
          {{ gridLonlat.lat.toFixed(6) }}</span
        >
      </div>
      <div id="myEcharts"></div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import * as Echarts from "echarts";
//风格填色样式
import map_style from "@/map/fillColor_styles";
import mapLegend from "@/map/legnd.vue";

export default {
  components: {
    mapLegend,
  },
  data() {
    return {
      airPortInfo: null,
      airPortSelect: null,
      echartsArray: {},
      ecElement: "风",
      gridLonlat: {
        lon: 0,
        lat: 0,
      },
      map: null,
      legndStyle: [],
      unit: "℃",
      element: ["tmp", "pop", "pres", "wind"],
      unitList: ["℃", "%", "hPa", "m/s"],
      colorType: ["w", "c", "c", "c"],
      focastHour: ["fh1", "fh2", "fh3", "fh4", "fh5", "fh6", "fh7", "fh8"],
      eleIndex: 3,
      percent: 0,
      gridData: {},
      TimeSlide: null,
      msg: null,
      featuresList: {},
      timeList: {},
      legndStyleList: {},
      focastNumber: 1,
      gridDataList: {},
      gridTimeList: {},
      gridColors: [
        "0,75,255",
        "0,150,255",
        "50,255,255",
        "200,255,255",
        "255,255,50",
        "255,200,0",
        "255,100,0",
        "230,0,0",
      ],
      weatherMapStyles: [],
      weatherLgdStyles: [],
      layerFillRangeColor: null,
      layerContour: null,
      layerPoint: null,
      gridEchart: false,
    };
  },
  mounted() {
    this.map = this.$store.state.map;
    this.getAirPortInfo();

    //获取元素
    var dv = document.getElementById("gridEchart");
    var x = 0;
    var y = 0;
    var l = 0;
    var t = 0;
    var isDown = false;
    //鼠标按下事件
    dv.onmousedown = function (e) {
      //获取x坐标和y坐标
      x = e.clientX;
      y = e.clientY;

      //获取左部和顶部的偏移量
      l = dv.offsetLeft;
      t = dv.offsetTop;
      //开关打开
      isDown = true;
      //设置样式
      dv.style.cursor = "move";
    };
    //鼠标移动
    window.onmousemove = function (e) {
      if (isDown == false) {
        return;
      }
      //获取x和y
      var nx = e.clientX;
      var ny = e.clientY;
      //计算移动后的左偏移量和顶部的偏移量
      var nl = nx - (x - l);
      var nt = ny - (y - t);

      dv.style.left = nl + "px";
      dv.style.top = nt + "px";
    };
    //鼠标抬起事件
    dv.onmouseup = function () {
      //开关关闭
      isDown = false;
      dv.style.cursor = "default";
    };
  },
  watch: {
    map() {
      let t = this;
      this.layerFillRangeColor = new WeatherMap.Layer.FillRangeColorLayer(
        "layerFillColor",
        {
          radius: 40,
          featureWeight: "value",
          featureRadius: "geoRadius",
        }
      );
      this.layerFillRangeColor.isSmooth = true;
      this.layerFillRangeColor.isAlwaySmooth = true;
      this.layerFillRangeColor.isShowGridline = false;
      this.layerFillRangeColor.isShowLabel = true;
      this.layerFillRangeColor.isGradient = false;
      this.layerFillRangeColor.deltaPixel = 1;
      this.layerFillRangeColor.alpha = 125;

      //等值线图层
      this.layerContour = new WeatherMap.Layer.Vector("layerContour", {
        renderers: ["Contour"],
      });

      this.layerPoint = new WeatherMap.Layer.Vector("point");

      this.map.addLayers([
        this.layerFillRangeColor,
        this.layerContour,
        this.layerPoint,
      ]);

      this.map.setCenter(new WeatherMap.LonLat(103.954, 30.576), 15);

      this.map.events.register("click", this.map, function (event) {
        if (
          t.layerFillRangeColor != null &&
          t.layerFillRangeColor.datasetGrid != null
        ) {
          // t.gridEchart = true;
          var lonlat = this.getLonLatFromPixel(event.xy);
          var point = new WeatherMap.Geometry.Point(lonlat.lon, lonlat.lat);
          var pointVector = new WeatherMap.Feature.Vector(point);
          pointVector.style = {
            fill: 0,
            fillOpacity: 0,
            strokeWidth: 1,
            strokeColor: "red",
            pointRadius: 6,
          };
          t.layerPoint.removeAllFeatures();
          t.layerPoint.addFeatures(pointVector);
          t.gridLonlat = lonlat;
          // t.getGridEcharts(lonlat);
        }
      });

      this.getGridData();
    },
  },
  methods: {
    //动画定时器
    loader() {
      let t = this;
      clearInterval(t.timer);
      t.timer = setInterval(() => {
        if (t.percent == 99 || t.percent == 0) {
          clearInterval(t.timer);
        } else {
          t.percent += 1;
        }
      }, 200);
    },
    getAirPortInfo() {
      $.post(this.$ipConfig.host + `getAirPortInfo`)
        .then((data) => {
          this.airPortInfo = data.dataList;
          this.airPortSelect = this.airPortInfo[0].ename;
        })
        .fail((x) => {
          this.$Message.error("机场信息获取错误!");
        });
    },
    changeAirPort(val) {
      this.airPortInfo.map((item) => {
        if (item.ename == val) {
          this.map.setCenter(new WeatherMap.LonLat(item.lon, item.lat), 15);
        }
      });
    },
    eleChange(index, ev) {
      $(".weatherLogo").find("div").removeClass("check");
      $(".weatherLogo").find("div").eq(index).addClass("check");
      this.eleIndex = index;
      this.unit = this.unitList[index];
      this.getGridData();
    },
    changeElement() {
      this.displayEcharts();
    },
    async getGridData() {
      var t = this;
      if (t.TimeSlide != null) {
        t.TimeSlide.clearTimeSlider();
      }
      t.featuresList[t.element[t.eleIndex]] = [];
      t.timeList[t.element[t.eleIndex]] = [];
      t.legndStyleList[t.element[t.eleIndex]] = [];

      $("#bottomPanel").css("display", "block");
      t.percent = 1;
      t.loader();

      let url = this.$ipConfig.host + "getOceanByFor&starttime=20211212&elements=";
      // url += "20211011";
      // url += "&elements=";
      switch (this.element[this.eleIndex]) {
        case "tmp":
          url += "T2";
          t.weatherMapStyles = map_style.weatherTemp_styles;
          break;
        case "pop":
          url += "RAINNC";
          t.weatherMapStyles = map_style.weatherPrec_styles;
          t.weatherMapStyles.splice(t.weatherMapStyles.length - 1, 1);
          break;
        case "pres":
          url += "PSFC";
          break;
        case "wind":
          url += "V10";
          t.weatherMapStyles = map_style.weatherWind_styles2;
          t.gridDataList["U10"] = [];
          let U10 = await $.get(
            this.$ipConfig.host +
              "getOceanByFor&starttime=20211212&elements=U10"
          );
          U10.dataList.map((e) => {
            t.gridDataList["U10"].push(e);
          });
          break;
      }
      t.layerFillRangeColor.items = t.weatherMapStyles;

      t.weatherLgdStyles = [];
      t.weatherMapStyles.map((item) => {
        t.weatherLgdStyles.push([
          item.start,
          item.end,
          {
            stroke: false,
            fill: true,
            fillColor:
              "rgb(" +
              item.startColor.red +
              "," +
              item.startColor.green +
              "," +
              item.startColor.blue +
              ")",
          },
        ]);
      });
      t.gridDataList[this.element[this.eleIndex]] = [];
      t.gridTimeList[this.element[this.eleIndex]] = [];
      $.get(url).then((data) => {
        data.dataList.map((e) => {
          let item = e.fTime;
          t.gridTimeList[t.element[t.eleIndex]].push(
            moment(
              item.substring(0, 4) +
                "-" +
                item.substring(4, 6) +
                "-" +
                item.substring(6, 8) +
                " " +
                item.substring(8, 10)
            ).format("YYYY/MM/DD/HH")
          );
          t.gridDataList[t.element[t.eleIndex]].push(e);
        });
        t.showTimeSlide();
        t.percent = 0;
      });
    },
    showTimeSlide() {
      let t = this;
      if (t.TimeSlide != null && t.TimeSlide.name != "radar") {
        t.TimeSlide.clearTimeSlider();
      }
      t.TimeSlide = new timeSlide(
        "radar",
        2,
        t.gridTimeList[t.element[t.eleIndex]],
        t.showRadar,
        t.clearRadar
      );
    },
    showRadar(folderName) {
      let curIndex;
      let t = this;
      this.gridTimeList[t.element[t.eleIndex]].map((m, index) => {
        if (m == folderName) {
          curIndex = index;
        }
      });
      let gridData = t.gridDataList[t.element[t.eleIndex]][curIndex];
      let datasetGrid = t.createGridData(gridData, curIndex);
      if (t.eleIndex == 3) {
        t.layerFillRangeColor.isWind = true;
      } else {
        t.layerFillRangeColor.isWind = false;
      }
      if (t.eleIndex == 2) {
        t.layerFillRangeColor.setDatasetGrid(null);
        t.layerFillRangeColor.refresh();
        let style = t.$comsys.getStyleByValue({ piece: 7, colorType: "c" }, [
          datasetGrid.dMin,
          datasetGrid.dMax,
        ]);
        let contour = new WeatherMap.Analysis.Contour();
        let dZValues = this.$comsys.getContourValuesByStyle(style);
        dZValues = dZValues.split(" ");
        dZValues.map((item, index) => {
          dZValues[index] = Number(item);
        });
        let result = contour.analysis(datasetGrid, dZValues, 6);
        let features = [];
        if (result.length > 0) {
          for (let key in result) {
            let geoline = result[key].geoline;
            let dZValue = result[key].dZValue;
            let feature = new WeatherMap.Feature.Vector(geoline);
            feature.attributes.dZValue = dZValue.toString();
            if (feature.attributes.dZValue == 0) {
              feature.style = {
                strokeDashstyle: "dot",
              };
            }
            features.push(feature);
          }
        }
        t.layerContour.renderer.labelField = "dZValue";
        t.layerContour.removeAllFeatures();
        t.layerContour.addFeatures(features);
        t.layerContour.refresh();
      } else {
        t.layerContour.removeAllFeatures();
        t.legndStyle = t.weatherLgdStyles;
        t.layerFillRangeColor.setDatasetGrid(datasetGrid);
        t.layerFillRangeColor.refresh();
      }
    },
    clearRadar() {
      this.layerFillRangeColor.setDatasetGrid(null);
    },
    createGridData(data, curIndex) {
      if (data.hasOwnProperty("datas")) {
        //格点数据
        var dvalues = data.datas.split(",");
        var bWind = false;
        var U10;
        if (this.eleIndex == 3) {
          bWind = true;
          U10 = this.gridDataList["U10"][curIndex].datas.split(",");
        }
        if (dvalues != null && dvalues.length > 0) {
          var dMin = 9999;
          var dMax = -9999;
          var datasetGrid = new WeatherMap.DatasetGrid(
            data.left,
            data.top,
            data.right,
            data.bottom,
            Number(data.rows),
            Number(data.cols),
            bWind ? 2 : 1
          );
          datasetGrid.noDataValue = data.noDataValue
            ? data.noDataValue
            : -99999;
          var grid = [];
          for (var i = Number(data.rows) - 1; i >= 0; i--) {
            var nIndexLine = Number(data.cols) * i;
            for (var j = 0; j < Number(data.cols); j++) {
              var nIndex = nIndexLine + j;
              var z = dvalues[nIndex];
              z = Math.floor(z * 100) / 100;
              if (bWind) {
                var v = Number(dvalues[nIndex]);
                var u = Number(U10[nIndex]);
                var speed = Math.sqrt(u * u + v * v);
                var dDirection = 270.0 - (Math.atan2(v, u) * 180.0) / Math.PI;
                z = speed;
                grid.push(Math.floor(speed * 10) / 10);
                grid.push(Math.floor(dDirection * 10) / 10);
              } else {
                grid.push(z);
              }
              if (z != 9999 && z != -9999) {
                if (z < dMin) dMin = z;
                if (z > dMax) dMax = z;
              }
            }
          }
          datasetGrid.grid = grid;
          datasetGrid.dMin = dMin;
          datasetGrid.dMax = dMax;
        }
      }
      return datasetGrid;
    },
    getGridEcharts(pt) {
      let t = this;
      t.percent = 1;
      t.loader();
      $.get(
        this.$ipConfig.getAirGridDataByLonLat +
          `?params={"time":"202111011","lon":"${pt.lon}","lat":"${pt.lat}"}`
      ).then((data) => {
        t.echartsArray = data;
        t.displayEcharts();
        t.percent = 0;
      });
    },
    displayEcharts() {
      let myChart = Echarts.init(document.getElementById("myEcharts"));
      let list;
      let xAxisData = [];
      let seriesData = [];
      let obj1 = {
        name: "",
        type: "line",
        data: [],
        symbol: "circle",
        lineStyle: {
          normal: {
            color: "rgb(183,232,47)",
            //type: 'dotted'
          },
        },
        itemStyle: {
          normal: {
            color: "rgb(45,140,240)", //折点颜色
          },
        },
      };
      if (this.ecElement == "气温") {
        list = this.echartsArray["T2"].data;
        Object.keys(list).map((key) => {
          xAxisData.push(key.substring(6, 10));
          obj1.name = "气温";
          obj1.data.push(list[key]);
        });
      } else if (this.ecElement == "降水") {
        list = this.echartsArray["RAINNC"].data;
        Object.keys(list).map((key) => {
          xAxisData.push(key.substring(6, 10));
          obj1.name = "降水";
          obj1.data.push(list[key]);
        });
      } else if (this.ecElement == "气压") {
        list = this.echartsArray["PSFC"].data;
        Object.keys(list).map((key) => {
          xAxisData.push(key.substring(6, 10));
          obj1.name = "气压";
          obj1.data.push(list[key]);
        });
      } else if (this.ecElement == "风") {
        let dims = {
          time: 0, //时间的维度是0
          windSpeed: 1, //风速的维度是1
          R: 2, //角度（0-360）的维度是2
        };
        let v10 = this.echartsArray["V10"].data;
        let U10 = this.echartsArray["U10"].data;
        let data2 = [];
        Object.keys(v10).map((key) => {
          xAxisData.push(key.substring(6, 10));
          seriesData.name = "风";
          var v = Number(v10[key]);
          var u = Number(U10[key]);
          var speed = Math.sqrt(u * u + v * v);
          var dDirection = 270.0 - (Math.atan2(v, u) * 180.0) / Math.PI;
          data2.push([key.substring(6, 10), speed.toFixed(2), dDirection]);
        });
        obj1 = {
          type: "line",
          symbol: "none", //不显示点
          smooth: true, //这句就是让曲线变平滑的
          connectNulls: true, //断点连接
          encode: {
            x: dims.time,
            y: dims.windSpeed,
          },
          lineStyle: {
            normal: {
              color: "rgb(183,232,47)",
              //type: 'dotted'
            },
          },
          data: data2,
          z: 3,
        };
        let obj2 = {
          type: "custom",
          renderItem: this.renderArrow,
          encode: {
            x: dims.time,
            y: dims.windSpeed,
          },
          data: data2,
          z: 10,
        };
        seriesData.push(obj2);
      }
      seriesData.push(obj1);
      // 绘制图表
      myChart.setOption(
        {
          title: {
            text: this.ecElement + "序列图",
            textStyle: {
              fontSize: 18,
              fontWeight: "bolder",
              color: "#fff", // 主标题文字颜色
            },
            left: "center",
          },
          tooltip: {},
          xAxis: {
            name: "日期",
            nameTextStyle: {
              color: "#fff",
            },
            boundaryGap: false,
            data: xAxisData,
            axisLabel: {
              // 坐标轴文本标签，详见axis.axisLabel
              show: true,
              rotate: 0,
              margin: 8,
              // formatter: null,
              textStyle: {
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                color: "#fff",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#fff", //更改坐标轴颜色
              },
            },
          },
          yAxis: {
            scale:true,
            axisTick: {
              show: true,
            },
            axisLabel: {
              // 坐标轴文本标签，详见axis.axisLabel
              show: true,
              rotate: 0,
              margin: 8,
              // formatter: null,
              textStyle: {
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                color: "#fff",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#fff", //更改坐标轴颜色
              },
            },
          },
          series: seriesData,
        },
        true
      );
    },
    renderArrow(param, api) {
      //数据参数顺序
      var dims = {
        time: 0,
        windSpeed: 1,
        R: 2,
      };
      var arrowSize = 12;

      var point = api.coord([api.value(dims.time), api.value(dims.windSpeed)]);
      let rotationData = api.value(dims.R);

      let obj = {
        type: "path",
        shape: {
          pathData:
            "M 146.5 230 L 141.298 239.011 L 146.5 219.595 L 151.702 239.011 Z", //绘制图形
          //'M31 16l-15-15v9h-26v12h26v9z',
          x: -arrowSize / 2,
          y: -arrowSize / 2,
          width: arrowSize,
          height: arrowSize,
        },
        rotation: -rotationData * (Math.PI / 180),
        //echarts文档-配置项： series-custom.renderItem.return_path. rotation
        //旋转（rotation）：默认值是 0。表示旋转的弧度值。正值表示逆时针旋转。
        //1) 角度转换为弧度公式：弧度=角度*(π /180 )
        //2)弧度转换为角度公式： 角度=弧度*（180/π）
        //平移（position）：默认值是 [0, 0]。表示 [横向平移的距离, 纵向平移的距离]。右和下为正值。
        position: point,
        style: api.style({
          stroke: "rgb(252,2,0)", //图形颜色
          lineWidth: 1,
        }),
      };
      return obj;
    },
  },
};
</script>
<style type="text/less">
.shadowBox {
  position: absolute;
  width: 100%;
  height: calc(100% - 80px);
  left: 0;
  top: 80px;
  /* background-color: rgba(255,255,255,1); */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.weatherLogo {
  position: absolute;
  right: 15px;
  top: 200px;
  text-align: right;
  z-index: 999;
}
.weatherLogo div {
  margin-top: 5px;
  cursor: pointer;
}
.weatherLogo div span {
  display: inline-block;
  vertical-align: middle;
  background-color: rgba(255, 255, 255, 0.6);
  box-shadow: 0 2px 4px 0 rgba(130, 130, 130, 0.5);
  position: relative;
  right: -15px;
  color: #000000;
  text-align: center;
  padding: 5px 20px 5px 10px;
  font-size: 12px;
  font-weight: normal;
}
.weatherLogo div .light {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  background-color: rgba(36, 39, 45, 0.8);
  text-align: center;
  border-radius: 50%;
  padding: 0;
  width: 32px;
  height: 32px;
  line-height: 30px;
}
.weatherLogo div .dark {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  background-color: rgba(36, 39, 45, 0.8);
  text-align: center;
  border-radius: 50%;
  padding: 0;
  width: 32px;
  height: 32px;
  line-height: 30px;
}
.weatherLogo div.check img.light {
  display: none;
}
.weatherLogo div.check img.dark {
  display: inline-block;
  vertical-align: middle;
  background-color: #ffd200;
}
.weatherLogo div.check img.light {
  display: none;
}
.weatherLogo div img.dark {
  display: none;
}

/*时间轴*/
div.timeSlider {
  bottom: 0px;
  width: 100%;
  right: 0;
  height: 72px;
  background-color: rgba(57, 77, 101, 0.7);
  color: #ffffff;
  z-index: 999;
  border: 1px solid #aaa;
}

div.timeControl {
  position: absolute;
  width: 100px;
  height: 28px;
  top: 6px;
  left: 50%;
  /*margin-left: -100px;*/
  /*display: none;*/
  cursor: pointer;
}
div.timeControl img {
  width: 22px;
}

div.timeLiner {
  position: absolute;
  width: 90%;
  height: 6px;
  left: 5%;
  top: 64%;
  border-top: 1px solid #cccccc;
  border-bottom: 1px solid rgb(241, 241, 241);
  background-color: #efefef;
  cursor: pointer;
}

div.timeNode {
  position: absolute;
  width: 16px;
  height: 16px;
  top: -5px;
  /*border-radius: 100%;*/
  /* background: transparent url("../../assets/img/tool/node.png") no-repeat scroll center center; */
  z-index: 2;
}
div.timeNode1 {
  position: absolute;
  width: 16px;
  height: 16px;
  top: -5px;
  /*border-radius: 100%;*/
  /* background: transparent url("../../../assets/img/tool/nodeMin.png") no-repeat scroll center center; */
  z-index: 2;
}

div.timeNodeTime {
  position: absolute;
  bottom: 15px;
  left: -12px;
  font-size: 10px;
  font-family: Arial;
  color: #ffffff;
}

div.timeNodeTime1 {
  position: absolute;
  bottom: 15px;
  left: -12px;
  font-size: 10px;
  font-family: Arial;
  color: #ffffff;
  display: none;
}

div.bottomPanel {
  position: absolute;
  width: 100%;
  right: 0;
  bottom: 0;
  z-index: 999;
  font-size: 12px;
  font-family: Microsoft YaHei;
}

div.bottomPanelImg {
  width: 40px;
  height: 12px;
  line-height: 12px;
  float: left;
  margin-left: 50%;
  background-color: #ffffff;
  border: 1px solid #aaaaab;
  border-bottom-color: #ffffff;
  text-align: center;
  cursor: pointer;
}
.airPortInfo {
  position: absolute;
  left: 50px;
  top: 100px;
  z-index: 999;
}
.gridEchart {
  width: 600px;
  height: 400px;
  position: absolute;
  right: 50px;
  bottom: 100px;
  z-index: 999;
  color: #ffffff;
  background: rgba(158, 164, 172, 0.7);
}
#myEcharts {
  width: 100%;
  height: calc(100% - 22px);
}

.airportForecast .ivu-select-selection {
  background: rgb(57,77,101);
  border: 1px solid rgb(57,77,101);
}
.airportForecast .ivu-select-input {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/waveForecast.vue